import { SimpleDateSelectType } from 'src/admin-entity/enum/search/simple-date-select-type.enum';

export function getStartEndDate(selectedValue: SimpleDateSelectType): {
    startDate: Date;
    endDate: Date;
} {
    const start = new Date();
    switch (selectedValue) {
        case 'yesterday':
            return {
                startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
                endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            };
        case 'today':
            return {
                startDate: new Date(),
                endDate: new Date(),
            };
        case 'week':
            return {
                startDate: new Date(start.setDate(start.getDate() - 7)),
                endDate: new Date(),
            };
        case 'month':
            return {
                startDate: new Date(start.setMonth(start.getMonth() - 1)),
                endDate: new Date(),
            };
        case '3month':
            return {
                startDate: new Date(start.setMonth(start.getMonth() - 3)),
                endDate: new Date(),
            };
        case '6month':
            return {
                startDate: new Date(start.setMonth(start.getMonth() - 6)),
                endDate: new Date(),
            };
        case '1year':
            return {
                startDate: new Date(start.setMonth(start.getMonth() - 12)),
                endDate: new Date(),
            };
        case 'allDate':
            return {
                startDate: undefined,
                endDate: undefined,
            };
        default:
            return {
                startDate: new Date(),
                endDate: new Date(),
            };
    }
}
